import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemLogoLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 770.9 156",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #ffbf02;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M190.1.7H12.8C5.7.7,0,6.5,0,13.5s5.7,12.8,12.8,12.8h177.3c7,0,12.8-5.7,12.8-12.8s-5.7-12.8-12.8-12.8Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M115.6,128.8H12.8c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8h102.8c7,0,12.8-5.7,12.8-12.8s-5.7-12.8-12.8-12.8Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M270.1,148.1l75.5-127.8c3.6-6.1,1.6-13.9-4.5-17.5-2-1.2-4.2-1.8-6.5-1.8-4.5,0-8.7,2.4-11,6.3l-59.3,100.4-5.2,8.8-5.2-8.8-15-25.4-1.8-3.1,1.8-3.1,33-55.9c3.6-6.1,1.6-13.9-4.5-17.5-2-1.2-4.2-1.8-6.5-1.8-4.5,0-8.7,2.4-11,6.3l-38.6,65.3h0s0,0,0,0h0c0,0-20.7,35.1-20.7,35.1l-5.2,8.8-5.2-8.8-21.6-36.6c0-.1-.2-.3-.2-.4-.1-.2-.3-.4-.4-.6-.1-.2-.2-.3-.4-.5-.1-.2-.2-.3-.4-.5-.2-.2-.3-.4-.5-.5-.1-.1-.2-.2-.4-.4-.2-.2-.4-.3-.5-.5-.1-.1-.3-.2-.4-.3-.2-.1-.4-.3-.6-.4-.2-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.3-.2-.1-.4-.2-.6-.3-.2,0-.3-.2-.5-.2-.2,0-.4-.2-.6-.3-.2,0-.3-.1-.5-.2-.2,0-.4-.1-.7-.2-.2,0-.4,0-.5-.1-.2,0-.4,0-.7-.1-.2,0-.4,0-.6,0-.2,0-.4,0-.6,0-.3,0-.5,0-.8,0-.1,0-.3,0-.4,0H12.8c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8h127.6l1.7,2.9,32.4,54.8c2.3,3.9,6.5,6.3,11,6.3s8.7-2.4,11-6.3l20.6-35,5.2-8.8,5.2,8.8,20.6,35c2.3,3.9,6.5,6.3,11,6.3s8.7-2.4,11-6.3Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "st1",
				points: "434.9 49.5 402.4 49.5 402.4 32.4 430.1 32.4 430.1 23.8 402.4 23.8 402.4 8.6 434.1 8.6 434.1 0 392.7 0 392.7 58.1 434.9 58.1 434.9 49.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M459,51.9c-6.5,0-9.9-2.7-10.3-7.9v-.5h-8.9v.5c.3,9.4,7.7,15.2,19.3,15.2s17.3-4.9,17.3-13.2-9.3-11.9-16-13.5c-.7-.1-1.3-.3-1.9-.4-5.2-1.1-8-1.8-8-5s3.8-4.6,7-4.6c6.6,0,8,3.6,8.5,6.3v.4h8.9v-.5c-.8-9.9-9.6-13.5-17.6-13.5s-16,4.7-16,12.2,9,11.1,15.6,12.7c.5.1,1,.2,1.5.3,4.7,1,8.8,1.8,8.8,6s-2.8,5.5-8.2,5.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M486,46.1c0,8.7,3.4,12.5,11.3,12.5s3,0,5-.5h.4v-7.4h-.6c-1.4.3-2,.4-3.3.4-3,0-4-.7-4-4.8v-22.5h7.8v-7.5h-7.8V3.3h-8.8v13.1h-5.9v7.5h5.9v22.2Z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "st1",
				x: 510.2,
				y: .6,
				width: 9.9,
				height: 9.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "st1",
				x: 510.6,
				y: 16.4,
				width: 8.8,
				height: 41.7
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M562.9,58.1v-25.5c0-5.9,3.5-9.7,9-9.7s6.6,3.2,6.6,8.6v26.6h8.8v-28.8c0-9.1-4.6-14.1-12.9-14.1s-9.7,2.2-13.3,6.7c-1.8-4.5-5.5-6.7-11-6.7s-9.5,2.8-11.7,5.5v-4.3h-8.8v41.7h8.8v-25.5c0-5.9,3.5-9.7,9-9.7s6.6,3.2,6.6,8.6v26.6h8.8Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M632.5,52.3c-.9,0-1.4-.7-1.4-4v-18.7c0-9.5-5.4-14.5-15.6-14.5-15.4,0-18.2,9-18.5,14.4v.5s8.9,0,8.9,0v-.5c.4-4.8,1.9-7.2,9.2-7.2s7.2,1.6,7.2,4.9-3.2,4.2-9.9,5.5c-10.7,2-17.4,5.1-17.4,14.2s5.6,12.2,13.8,12.2,10.8-2.1,13.7-6.2c.7,3.8,2.8,5.5,6.8,5.5s2.7-.2,4.1-.5h.4v-5.9h-.6c-.4.2-.7.2-.9.2ZM622.4,41.7c0,6.4-4.4,10.2-11.7,10.2s-6.4-1.7-6.4-5.4,2.7-5.7,9.8-7.2c3.9-.8,6.7-1.6,8.3-2.5v4.9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M656.7,51.1c-3,0-4-.7-4-4.8v-22.5h7.8v-7.5h-7.8V3.3h-8.8v13.1h-5.9v7.5h5.9v22.2c0,8.7,3.4,12.5,11.3,12.5s3,0,5-.5h.4v-7.4h-.6c-1.4.3-2,.4-3.3.4Z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "st1",
				x: 667.9,
				y: .6,
				width: 9.9,
				height: 9.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "st1",
				x: 668.4,
				y: 16.4,
				width: 8.8,
				height: 41.7
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M706.2,15.1c-12.7,0-20.9,8.7-20.9,22.1s8.2,22.1,20.9,22.1,20.9-8.7,20.9-22.1-8.2-22.1-20.8-22.1ZM706.2,51.8c-7.4,0-11.8-5.5-11.8-14.6s4.3-14.6,11.8-14.6,11.6,5.5,11.6,14.6-4.3,14.6-11.6,14.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M756.9,15.2c-7.1,0-11.1,3.1-13.1,5.5v-4.3h-8.8v41.7h8.8v-25.5c0-5.9,4.1-9.7,10.5-9.7s7.8,2.9,7.8,8.6v26.6h8.8v-28.8c0-8.7-5.4-14.1-14.1-14.1Z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "st1",
				points: "441 140.4 429.5 96.7 419.4 96.7 408 140.3 398.2 96.7 388 96.7 402.4 154.8 412.7 154.8 424.5 110 436.3 154.8 446.5 154.8 461 96.7 450.8 96.7 441 140.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M483.1,111.8c-12.7,0-20.9,8.7-20.9,22.1s8.2,22.1,20.9,22.1,20.9-8.7,20.9-22.1-8.2-22.1-20.8-22.1ZM483.1,148.5c-7.4,0-11.8-5.5-11.8-14.6s4.3-14.6,11.8-14.6,11.6,5.5,11.6,14.6-4.3,14.6-11.6,14.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M531.3,112.1c-4.6,0-8.1,2.4-10.6,7.3v-6.3h-8.8v41.7h8.8v-21.6c0-7.4,4.8-12.6,11.7-12.6s1.7,0,2.6.2h.6c0,0,0-8.4,0-8.4h-.4c-1.3-.2-2.4-.3-3.8-.3Z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "st1",
				x: 542.1,
				y: 96.7,
				width: 8.8,
				height: 58.1
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M590,117.2c-2.2-2.6-6-5.4-12.2-5.4-11.2,0-18.8,8.9-18.8,22.1s7.5,22,18.8,22,9.9-2.7,12.2-5.2v4.1h8.8v-58.1h-8.8v20.5ZM579,148.4c-8.1,0-10.9-7.8-10.9-14.5s2.9-14.5,10.9-14.5,10.8,5.6,10.8,14.5-4.2,14.5-10.8,14.5Z"
			})
		] })
	]
});
export default SvgSystemLogoLight;
